import React, { FC, useState, useCallback } from 'react';
import { useUtils } from '../../../../../UtilsProvider';
import type { WidgetThumbProps } from '../MyWidgets.types';

import style from './MyWidgetThumb.scss';

export const MyWidgetThumb: FC<WidgetThumbProps> = ({ thumb, presetName = '' }) => {
  const [hasError, setError] = useState<boolean>(false);
  const { media } = useUtils();

  const handleError = useCallback(() => {
    setError(true);
  }, [setError]);

  const imgSrc =
    thumb && !hasError ? thumb : media.getMediaUrl('advancedStylePanel/widgetDesign/presetPlaceholder.svg');

  return (
    <div className={style.thumb}>
      <img className={style.thumbImg} src={imgSrc} onError={handleError} alt={presetName} />
    </div>
  );
};
